import * as React from 'react';

interface Props {
  questionId: number;
  question: string;
  answer: string;
}

const QuestionComponent = (props: Props) => (
  <div>
    <div
      className="accordion-toggle question-toggle collapsed pointer"
      data-toggle="collapse"
      data-parent="#faqAccordion"
      data-target={'#question' + props.questionId}
    >
      <p>
        <span className="arrow-right-grey"/>
        <span className="faq-question">
          {props.question}
        </span>
      </p>
    </div>
    <div
      id={'question' + props.questionId}
      className="collapse padding-left-30"
    >
      <p>
        <div dangerouslySetInnerHTML={{__html: props.answer}} />
      </p>
    </div>
    <div className="gap-20"/>
  </div>
);

export default QuestionComponent;



// WEBPACK FOOTER //
// ./src/modules/faq/Question.component.tsx